module.exports = __webpack_public_path__ + "img/1.ecde5a6a.jpg";